import { useList } from "@refinedev/core";
import { Asset, AssetClass, Maybe } from "types";
import { useSession } from "./useSession";

export const useOrganizationAssets = ({
  assetClass = "Equity",
}: {
  assetClass?: AssetClass;
}) => {
  const { currentOrganization } = useSession();
  const { data: tickersData, isLoading: isLoadingAssets } = useList<Asset>({
    resource: `api/assets/${assetClass}/clients_tickers?organization_id=${currentOrganization?.id}`,
    queryOptions: {
      enabled: Boolean(currentOrganization?.id),
      staleTime: 1000 * 60 * 10, // 10 minutes
    },
  });
  const assets = tickersData?.data;

  const getAsset = (ticker: string): Maybe<Asset> =>
    assets?.find((x) => x.ticker === ticker) ?? null;

  return {
    assets,
    isLoadingAssets,
    getAsset,
  };
};
